// Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
// Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
define('membershipdirectory.View', [
    'PageType.Base.View',
    'NVT.membershipdirectory.Collection',
    'NVT.membershipdirectory.Collection.View',
    'GlobalViews.Pagination.View',
	'GlobalViews.ShowingCurrent.View',
    'GlobalViews.Confirmation.View',
    'membershipdirectory_list.tpl',
    'Utils',
    'SC.Configuration',
    'Backbone', 
    'Backbone.CollectionView',
    'membershipdirectory.Details.View',
    'AjaxRequestsKiller',
    'UrlHelper',
    'membershipdirectoryProfile.View',
    'underscore',
    'NVT.membershipdirectory.membershipdirectory.SS2Model'
], function (
    PageTypeBaseView,
    nvtMembershipDirectoryCollection,
    nvtMembershipDirectoryCollectionView,
    GlobalViewsPaginationView,
	GlobalViewsShowingCurrentView  ,
    ConfirmationView,
    membershipdirectory_list_tpl,
    Utils,
    Configuration,
    Backbone,
    BackboneCollectionView,
    membershipdirectoryDetailsView,
    AjaxRequestsKiller,
    UrlHelper_1,
    membershipdirectoryProfileView,
    _,
    membershipdirectorySS2Model
) {
    'use strict';

    return Backbone.View.extend({
        template: membershipdirectory_list_tpl,

        initialize: function initialize (options) {
            this.options.showCurrentPage = true;
            this.routerArguments = options.routerArguments[0];
            this.collection = new nvtMembershipDirectoryCollection();
            this.options.isUrlAlertMesg = true;
            this.collection.on('reset sync add remove changed destroy', this.render, this);

            // this.options.application.layout.on('afterAppendToDom', function() {
            //     var routerArguments = this._currentView.options.routerArguments[0];
            //     var getorgmemno = routerArguments ? Utils.parseUrlOptions(routerArguments) : { orgmemno : '' };
            //     var getcurrentvalue = getorgmemno.orgmemno || '';
            //     if(getcurrentvalue){
            //         var getlistselect = this._currentView.collection.models.filter(function(spdata) {
            //             return spdata.get('MembershipNumber') == getcurrentvalue
            //         });
            //         if (this._currentView.options.application.layout && getlistselect.length > 0) {

            //             var modalMessage = new membershipdirectoryProfileView({ container: this._currentView.options.container,image:getlistselect[0].get('imgurl') ,uenno:getlistselect[0].get('uenno'),getcompanyprofile: getlistselect[0].get('profile'),redirectUrl: getlistselect[0].get('Website'),memStatus:getlistselect[0].get('memStatus')});
            //                 modalMessage.modalClass ='modal-md';
            //                 modalMessage.title= getcurrentvalue +' - '+getlistselect[0].get('Company') || '',
            //                 this._currentView.options.container.layout.showInModal(modalMessage);
            //             return false;
            //         }
            //         else{
            //                 var modalMessage = new membershipdirectoryProfileView({ container: this._currentView.options.container ,image:'',uenno:'',getcompanyprofile: 'No member record found.',redirectUrl:'',memStatus:''});
            //                 modalMessage.modalClass ='modal-md';
            //                 modalMessage.title= getcurrentvalue  || '',
            //                 this._currentView.options.container.layout.showInModal(modalMessage);
            //             return false;
            //         }
            //     }
            // })           

            this.options.application.layout.on('afterAppendToDom', function() {
                var routerArguments = this._currentView.options.routerArguments[0];
                var getorgmemno = routerArguments ? Utils.parseUrlOptions(routerArguments) : { orgmemno : '' };
                var getcurrentvalue = getorgmemno.orgmemno || '';
                var self = this;
                if(getcurrentvalue){
                    if (getcurrentvalue) {
                        var memSS2Model = new membershipdirectorySS2Model();
                            memSS2Model.fetch({
                            data: {
                                'membershipnumber': getcurrentvalue,
                                'getmethod': 'memberprofiledetails'
                            }
                        }).done(function (response) {
                            if(response.records.length)
                            {
                                var bindProfileDetailsDisplay = { container: self._currentView.options.container,image:response.records[0].imgurl ,compname:response.records[0].Company,uenno:response.records[0].uenno,getcompanyprofile: response.records[0].profile,redirectUrl: response.records[0].Website,memStatus:response.records[0].memStatus};
                                var bindProfileDetailsNotDisplay = { container: self._currentView.options.container ,image:'',compname:response.records[0].Company ,uenno:response.records[0].uenno,getcompanyprofile: response.records[0].responceMsg,redirectUrl:'',memStatus:''};
                                //var NowDisplyMessageis = response.records[0].memStatusID == '2' ? bindProfileDetailsNotDisplay : bindProfileDetailsDisplay;
                                var NowDisplyMessageis = response.records[0].responceMsg != '' ? bindProfileDetailsNotDisplay : bindProfileDetailsDisplay;
                                var modalMessage = new membershipdirectoryProfileView(NowDisplyMessageis);
                                    modalMessage.modalClass ='modal-md';
                                    modalMessage.title= 'Membership Information',
                                    //modalMessage.title= getcurrentvalue +' - '+response.records[0].Company || '',
                                    self._currentView.options.container.layout.showInModal(modalMessage);
                                return false;
                            }
                            else{
                                var modalMessage = new membershipdirectoryProfileView({ container: self._currentView.options.container ,image:'',compname:'',uenno:getcurrentvalue,getcompanyprofile: 'No member record found.',redirectUrl:'',memStatus:''});
                                    modalMessage.modalClass ='modal-md';
                                    modalMessage.title= 'Membership Information',
                                    self._currentView.options.container.layout.showInModal(modalMessage);
                                return false;
                            }
                        });
                    }
                }
			});
        }
           
	,	title: Utils.translate("Members’ Directory")

	,	page_header: Utils.translate("Members’ Directory")

    ,   getSelectedMenu: function getSelectedMenu () {
            return 'membershipdirectorylist'
        }

    ,    getBreadcrumbPages: function () {
            return {
                text: Utils.translate("Members’ Directory"),
                href: '/membershipdirectory'
            };
        }

    ,   beforeShowContent: function beforeShowContent(param) {
            const options = this.routerArguments
                ? Utils.parseUrlOptions(this.routerArguments)
                : { page: 1 };
    
                this.page = options.page || 1;
            let MembershipNumber = '';
            if(options.orgmemno && this.options.isUrlAlertMesg)
            {
                MembershipNumber = options.orgmemno;  
                this.options.isUrlAlertMesg = false;
            }
            else{
                MembershipNumber = jQuery("#txtmembershipnumber").val() ? jQuery("#txtmembershipnumber").val() : '';    
            }

            let Company = jQuery("#txtcompanynamecontaining").val() ? jQuery("#txtcompanynamecontaining").val() : '';
            let UENNO = jQuery("#txtuenno").val() ? jQuery("#txtuenno").val() : '';
            let IndustryGroup = jQuery("#selectindustrygroup").val() ? jQuery("#selectindustrygroup").val() : '';

            var parameters = {};
            parameters['page'] = this.page;   
            parameters['pageSize'] =  20;
            parameters['MembershipNumber'] = MembershipNumber;
            parameters['Company'] =  Company;
            parameters['UENNO'] = UENNO;
            parameters['IndustryGroup'] = IndustryGroup;

        return this.collection.update({
                data: parameters,
                page: this.page,
                pageSize:20,
                recordsPerPage: 20,
                killerId: AjaxRequestsKiller.getKillerId(),
                reset: true,
            });       
        }

    ,   resetFilter : function(e) {

                jQuery("#txtmembershipnumber").val('');
                jQuery("#txtcompanynamecontaining").val('') ;
                jQuery("#txtuenno").val('');
                jQuery("#selectindustrygroup").val('') 
            let newUrlRedirectFailure = '/membershipdirectory';
            let new_hash = Utils.addParamsToUrl(newUrlRedirectFailure, {});
                Backbone.history.navigate(new_hash, { trigger: true, replace: true });


            // const options = this.routerArguments
            // ? Utils.parseUrlOptions(this.routerArguments)
            // : { page: 1 };

            // this.page = 1;

            // var parameters = {};
            // parameters['page'] = this.page;   
            // parameters['pageSize'] =  20;
            // parameters['MembershipNumber'] = '';
            // parameters['Company'] =  '';
            // parameters['UENNO'] = '';
            // parameters['IndustryGroup'] = '';

            // return this.collection.update({
            //         data: parameters,
            //         page: this.page,
            //         pageSize:20,
            //         recordsPerPage: 20,
            //         killerId: AjaxRequestsKiller.getKillerId(),
            //         reset: true,
            // });       
        }
    

    ,    membership_directory_filter : function(){
            var self = this;
        }

    ,    events:
        {
            'click [data-action="dt_membership_directory_filter"]': 'beforeShowContent',
            'click [data-action="data-action-company-profile-info"]': 'companyProfileinfo',
            'click [data-action="dt_membership_directory_filter_clear"]': 'resetFilter',
            // 'mouseover [data-action="data-action-company-profile-info"]': 'companyProfileinfo'
        }


    ,	  companyProfileinfo : function(e){
            var self = this;
            var getcurrentvalue = e.currentTarget.value
                if(getcurrentvalue){
                    var getlistselect = this.collection.models.filter(function(spdata) {
                        return spdata.get('MembershipNumber') == getcurrentvalue
                    });
                    if (this.options.application.layout && getlistselect.length > 0) {

                        var modalMessage = new membershipdirectoryProfileView({ container: this.options.container,image:getlistselect[0].get('imgurl') ,compname:getlistselect[0].get('Company'),uenno:getlistselect[0].get('uenno'),getcompanyprofile: getlistselect[0].get('profile'),redirectUrl: getlistselect[0].get('Website'),memStatus:getlistselect[0].get('memStatus')});
                            modalMessage.modalClass ='modal-md';
                            modalMessage.title= 'Membership Information',
                            //modalMessage.title= getcurrentvalue +' - '+getlistselect[0].get('Company') || '',
                            this.options.container.layout.showInModal(modalMessage);
                        return false;
                    }
            }
        }


    ,    childViews : {
            'GlobalViews.Pagination': function () {
                return new GlobalViewsPaginationView(_.extend({
                    current_page: this.collection.page || 0,
                    totalPages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage) || 0,
                    pager: function (page) {
                        return "/" + ( parseInt(page) > 1
                            ? UrlHelper_1.UrlHelper.setUrlParameter(Backbone.history.fragment, 'page', parseInt(page))
                            : UrlHelper_1.UrlHelper.removeUrlParameter(Backbone.history.fragment, 'page'));
                    },
                }, Configuration.get('defaultPaginationSettings')));
            }

        ,	'GlobalViews.ShowCurrentPage': function()
           {
                return new GlobalViewsShowingCurrentView({
                    current_page: this.collection.page,
                    items_per_page: this.collection.recordsPerPage
                 ,	total_items: this.collection.totalRecordsFound
                ,	total_pages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
                });
            }
        ,    'NVT.membershipdirectory.Collection': function () {
                return new BackboneCollectionView({
                    'collection': this.collection,        
                    'childView': membershipdirectoryDetailsView,
                    'viewsPerRow': 1
                })
            }        
        },

         getContext: function ()
        {      
            let totoalPages = Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage);
                // if(totoalPages < this.collection.page)
                // {
                //      Backbone.history.navigate('#membershipdirectory', { trigger: true });
                // }
          return {     
            // @property {Boolean} page_header
            page_header : this.page_header,
            // @property {Boolean} collection
            rowcollection: this.collection,
            // @property {Boolean} showPagination
            showPagination: !!(this.collection.totalRecordsFound && this.collection.recordsPerPage),
            // @property {Boolean} showCurrentPage
           showCurrentPage: this.options.showCurrentPage ,
            // @property {Boolean} totalRecordsFound
           showItems: !!this.collection.totalRecordsFound,
           //totalRecords: this.collection.totalRecordsFound,
            // @property {string} showMembershipNumber
           showMembershipNumber :this.collection.showMembershipNumber || '',
            // @property {string} showCompany
           showCompany: this.collection.showCompany || '',
            // @property {string} showUENNO
           showUENNO: this.collection.showUENNO || '',
            // @property {string} showIndustryGroupList
           showIndustryGroupList : this.collection.showIndustryGroupList,
            // @property {string} totoalPages
           totoalPages : totoalPages
          }
        }   
    })
});
